import { MouseEventHandler } from 'react'
import { IconButton, Modal, Paper } from '@mui/material'

import CloseIcon from '@mui/icons-material/Close'
import { CodeCard } from 'src/components/code-card'
import { useStyles } from './styles'

interface IQRCodeModalProps {
  handleClose: MouseEventHandler<HTMLButtonElement>
  open: boolean
  productId?: string
  simpleProductId?: string
}

const QRCodeModal = ({ handleClose, open, productId, simpleProductId }: IQRCodeModalProps) => {
  const classes = useStyles()

  return (
    <Modal open={open} onClose={handleClose}>
      <Paper className={classes.modalWrapper}>
        <IconButton className={classes.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <CodeCard disableBorder productId={productId} simpleProductId={simpleProductId} />
      </Paper>
    </Modal>
  )
}

export { QRCodeModal }
